// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../booqadmin/node_modules/css-loader/index.js!../../../booqadmin/node_modules/sass-loader/dist/cjs.js!./admin.lte.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../booqadmin/node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../booqadmin/node_modules/css-loader/index.js!../../../booqadmin/node_modules/sass-loader/dist/cjs.js!./admin.lte.scss", function() {
			var newContent = require("!!../../../booqadmin/node_modules/css-loader/index.js!../../../booqadmin/node_modules/sass-loader/dist/cjs.js!./admin.lte.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}